import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import "./styles.css";
import Title from "../Title";
import { getTransactions } from "../../../APIs";
import { Link } from "react-router-dom";
import { stampToDate } from "../../../Library/datetime";
import { getFomattedAmt } from "../../../Library/helpers";

const PaymentDetailsModal = ({ showPaymentDetails, onClose, orderId, paymentDetails, setIsPaymentDetailAvailable }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    getTransactions(orderId, (err, res) => {
      if (err) {
        console.error("Error Fetching Order Payment Details !!");
      } else {
        if(res.length) setIsPaymentDetailAvailable(true);
        res = res[0];
        setData(res);
      }
    });
  }, []);
  return (
    <Modal
      size={"4xl"}
      isOpen={showPaymentDetails}
      onClose={onClose}
      isCentered={true}
    >
      <ModalOverlay />
      <ModalContent className="payment-details-modal">
        <ModalCloseButton />
        <Title variant="md" fixed>
          Payment Details
        </Title>
        {((data && data.refNo) || (paymentDetails && paymentDetails.refNo)) ? <div className="payment-details">
          <div className="details-container">
            <p>
              <span className="key">Transaction ID:</span>
              <span className="value">{paymentDetails.refNo || (data && data.refNo) || "-"}</span>
            </p>
            <p>
              <span className="key">Amount Paid:</span>
              <span className="value">{(paymentDetails && paymentDetails.amt) ? getFomattedAmt(paymentDetails.amt) : (getFomattedAmt(data.amt) || "-")}</span>
            </p>
            <p>
              <span className="key">Payment Date:</span>
              <span className="value">
              {paymentDetails && paymentDetails.ts
                ? stampToDate(paymentDetails.ts)
                : (data && data.ts
                ? stampToDate(data.ts)
                : "-")
              }
              </span>
            </p>
          </div>
          <Link className="view-screenshot" to={(data && data.ssUrl) ? data.ssUrl : ((paymentDetails && paymentDetails.ssUrl) ? paymentDetails.ssUrl : "")} target="_blank">
            View Screenshot
          </Link>
        </div> : null}
      </ModalContent>
    </Modal>
  );
};

export default PaymentDetailsModal;
